import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  name: string
  label: string
  showCounter?: boolean
  counterClassName?: string
  counterText?: string
}

export const FormLabel: React.FC<Props> = ({
  name,
  label,
  showCounter,
  counterClassName,
  counterText,
}) => (
  <div className={css.form_label_wrap}>
    <label htmlFor={name} className={css.form_label}>
      {label}
    </label>

    {showCounter && counterText && (
      <div
        className={clsJoin(
          css.form_label_badge,
          counterClassName && css[counterClassName]
        )}
      >
        {counterText}
      </div>
    )}
  </div>
)
